var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCard1Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 99,
    viewBox: "0 0 113 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/buildings-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/buildings-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.896 93.75H21.6148C14.1669 93.75 10.4167 89.9999 10.4167 82.5519V21.6147C10.4167 14.1668 14.1669 10.4167 21.6148 10.4167H44.0106C51.4585 10.4167 55.2083 14.1668 55.2083 21.6147V31.25",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M90.4688 43.8541V101.979C90.4688 110.365 86.3023 114.583 77.9169 114.583H47.5001C39.1147 114.583 34.896 110.365 34.896 101.979V43.8541C34.896 35.4687 39.1147 31.25 47.5001 31.25H77.9169C86.3023 31.25 90.4688 35.4687 90.4688 43.8541Z",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.7917 31.25V21.6147C69.7917 14.1668 73.5416 10.4167 80.9895 10.4167H103.385C110.833 10.4167 114.583 14.1668 114.583 21.6147V82.5519C114.583 89.9999 110.833 93.75 103.385 93.75H90.4687",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.0833 57.2917H72.9166",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M52.0833 72.9167H72.9166",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M62.5 114.583V98.9583",
    stroke: "#EFEFEF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCard1Icon);
export default __webpack_public_path__ + "static/media/home_card1_icon.3a3dd678766de549e0a77f74f2fc8cf3.svg";
export { ForwardRef as ReactComponent };